;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { logSentryError } from './logSentry';

export function addTalentPixel(source: string | null) {
  try {
    if (source && (source === 'Talent.com' || source === 'talent.com')) {
      const talentPixelWrapper = document.createElement('p');
      const talentPixel = document.createElement('IMG');
      const providedURL = 'https://www.talent.com/tracker/img-pixel.php?tracker=synergiebe';
      talentPixel.setAttribute('src', providedURL);
      talentPixelWrapper.appendChild(talentPixel);
      document.body.appendChild(talentPixelWrapper);
    }
  } catch (error) {
    logSentryError(error);
  }
}
